import { useDependencies } from '@servicetitan/react-ioc';
import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { SettingsNavigation } from './settings-navigation';
import {
    MarketingMainSettingsRoutes,
    MarketingMfe,
    MarketingRouteStore,
    MarketingSection,
    MarketingSettingsPageTitles,
    MfeBasenames,
} from '@servicetitan/marketing-global-route';
import { StandaloneRootStore } from '@servicetitan/standalone-root';
import { OnboardingBrandState } from '@servicetitan/marketing-services-api/dist/settings';
import { FeaturesStore } from '../../../../features/stores/features.store';
import { SettingsNavItem } from '../../utils/types';

export const SettingsSidebar = observer(() => {
    const [
        { onboarding },
        {
            features: { isCustomizableAttributionWindowEnabled, isCustomizableCustomFieldsEnabled },
            isSMSRegistrationEnabled,
        },
        { getPathnameWithStandaloneRoot },
    ] = useDependencies(StandaloneRootStore, FeaturesStore, MarketingRouteStore);

    const isOnboardingCompleted = onboarding.state === OnboardingBrandState.Completed;

    const pages = useMemo(() => {
        const navItems: SettingsNavItem[] = [
            {
                title: MarketingSettingsPageTitles[MarketingMainSettingsRoutes.SettingsBrand],
                path: getPathnameWithStandaloneRoot(
                    MarketingSection.Settings,
                    `${MfeBasenames[MarketingMfe.MainSettings]}${MarketingMainSettingsRoutes.SettingsBrand}`,
                ),
            },
            {
                title: MarketingSettingsPageTitles[MarketingMainSettingsRoutes.SettingsEmail],
                // numberOfErrors: brandSettingsStore.numberOfInvalidEmails,
                path: getPathnameWithStandaloneRoot(
                    MarketingSection.Settings,
                    `${MfeBasenames[MarketingMfe.MainSettings]}${MarketingMainSettingsRoutes.SettingsEmail}`,
                ),
                disabled: !isOnboardingCompleted,
                // incomplete:
                //     location.pathname !== MarketingMainSettingsRoutes.SettingsEmailConfiguration &&
                //     location.pathname !== MarketingMainSettingsRoutes.SettingsEmailBrands &&
                //     location.pathname !== MarketingMainSettingsRoutes.SettingsEmail,
            },
        ];

        if (isSMSRegistrationEnabled) {
            navItems.push({
                title: MarketingSettingsPageTitles[MarketingMainSettingsRoutes.SettingsSMS],
                path: getPathnameWithStandaloneRoot(
                    MarketingSection.Settings,
                    `${MfeBasenames[MarketingMfe.MainSettings]}${MarketingMainSettingsRoutes.SettingsSMS}`,
                ),
                disabled: !isOnboardingCompleted,
            });
        }

        if (isCustomizableAttributionWindowEnabled) {
            navItems.push({
                title: 'Attribution Settings',
                path: getPathnameWithStandaloneRoot(
                    MarketingSection.Settings,
                    MfeBasenames[MarketingMfe.RevenueAttribution],
                ),
                disabled: !isOnboardingCompleted,
            });
        }

        if (isCustomizableCustomFieldsEnabled) {
            navItems.push({
                title: 'Fields Settings',
                path: getPathnameWithStandaloneRoot(
                    MarketingSection.Settings,
                    MfeBasenames[MarketingMfe.FieldsSettings],
                ),
                disabled: !isOnboardingCompleted,
            });
        }

        return {
            title: 'Settings',
            navGroups: [
                {
                    key: 'Settings',
                    items: navItems,
                },
            ],
        };
    }, [
        getPathnameWithStandaloneRoot,
        isOnboardingCompleted,
        isSMSRegistrationEnabled,
        isCustomizableAttributionWindowEnabled,
        isCustomizableCustomFieldsEnabled,
    ]);

    return <SettingsNavigation structure={pages} />;
});
